// Shared date formatting so every table/drawer in the app reads dates the
// same way ("Oct 12, 2026" / "Oct 12, 2026, 2:30 PM") instead of each page
// picking its own toLocaleDateString()/toLocaleString() call, which mixes
// locale-default formats like "16/10/2026" in with this one.
export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export function formatDateTime(dateString: string): string {
  return new Date(dateString).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}
